import React from 'react'
import CashFundPreferencesForm from 'registry/forms/cash-fund-preferences-form'
import { LegacyCashFundPreferenceSettingsProps } from 'registry/settings-page/cash-fund-preferences/LegacyCashFundPreferenceSettings/LegacyCashFundPreferenceSettings.types'

const LegacyCashFundPreferenceSettings: React.FC<
  LegacyCashFundPreferenceSettingsProps
> = (props) => {
  const { isEditable } = props
  return (
    <>
      <p className="mbl h6">
        Choose how you'd like to receive money from gift givers. Each option you
        check will be offered to your gift givers to select from.
      </p>
      <CashFundPreferencesForm {...props} />
      {!isEditable && (
        <small className="text-muted mbm">
          Only the registry owner can manage cash funds.
        </small>
      )}
    </>
  )
}

export default LegacyCashFundPreferenceSettings
